import { DataSync } from "./DataSync.js";
export const DataSyncManager = {
    _onDataSync: new Map(),
    registerDataSync(dataType, onSync, onUnSync) {
        const sync = new DataSync();
        if (onSync) {
            sync.addOnSync(onSync);
        }
        if (onUnSync) {
            sync.addOnUnSync(onUnSync);
        }
        this._onDataSync.set(dataType, sync);
        return sync;
    },
    getDataSync(id) {
        const dataSync = this._onDataSync.get(id);
        if (!dataSync)
            return false;
        return dataSync;
    }
};
